const styles = {
  listItem: {
    bgcolor: 'background.paper',
    padding: 0,
    '& .Mui-selected': {
      color: '#154A8A',
    },
  },
  listItemWithError: {
    bgcolor: '#FAF0F1',
    color: '#AE2633',
    padding: 0,
    '& .Mui-selected': {
      bgcolor: '#FFE7EA',
    },
    '&:hover': {
      bgcolor: '#FFE7EA',
    }
  },
  listItemForDragging: {
    bgcolor: '#154A8A36',
    padding: 0,
    '& .Mui-selected': {
      color: '#154A8A',
    },
  },
  listItemForDraggingWithError: {
    bgcolor: '#FDD6DA',
    color: '#AE2633',
    padding: 0,
    '& .Mui-selected': {
      bgcolor: '#FFE7EA',
    },
    '&:hover': {
      bgcolor: '#FFE7EA',
    }
  },
  listItemButton: {
    pl: '12px',
    '&.MuiListItemButton-root.Mui-disabled': {
        cursor: 'pointer',
    },
    '&.Mui-disabled > :not(.MuiListItemButton-root):not(.MuiListItemText-root)': {
      pointerEvents: 'auto',
    },
  },
  listItemText: {
    ml: '28px',
  },
  nestedList: {
    py: '4px',
    ml: '4rem',
  },
  nestedListItem: {
    padding: 0,
  },
  nestedListItemText: {
    ml: '0rem',
    fontSize: '12px',
  },
  checkbox: {
    padding: 0,
    mr: '0.25rem',
  },
  skeletonRowContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  skeletonRow: {
    backgroundColor: '#f0f7ff',
    width: '84%',
    height: '60px',
    '&: nth-of-type(odd)': {
      height: '20px',
    }
  },
  editInput: {
    flex: 1,
    ml: '28px',
    fontSize: '14px',
    height: '26px',
    border: '1px solid #154A8A',
    borderRadius: '3px',
    px: '6px',
    color: '#000000',
    minWidth: 0,
  },
  renamedDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    bgcolor: '#0091D6',
    flex: '0 0 auto',
    mr: '4px',
  },
  rowActionsContainer: {
    display: 'flex',
    flex: '0 0 auto',
  },
  hoverIcon: {
    padding: '3px',
  },
}

export default styles;